export default __webpack_public_path__ + "static/media/t_angel.aa1842e5.png";